import { STELLATE_URLS } from './constants'

const getStellateUrl = ({ envUrl, BOOTSTRAP_ENV, apiUrl }) => {
  try {
    if (envUrl === 'local.priceline.com') {
      return STELLATE_URLS[BOOTSTRAP_ENV.replace('-', '')]
    }
    return `https://${envUrl}/graphcdn`
  } catch (err) {
    return apiUrl
  }
}

export { getStellateUrl }
